import { useEffect, useState } from 'react'

import Api from 'services/api'

import { PremiumFeature } from 'types/PremiumFeature'

const usePremiumFeatures = () => {
  const [premiumFeatures, setPremiumFeatures] = useState<Array<PremiumFeature>>([])
  const [arePremiumFeaturesLoaded, setArePremiumFeaturesLoaded] = useState(false)

  useEffect(() => {
    Api.PremiumFeatures.list()
      .then((res : Array<PremiumFeature>) => {
        setPremiumFeatures(res)
      })
      .catch(() => {
        setPremiumFeatures([])
      })
      .finally(() => {
        setArePremiumFeaturesLoaded(true)
      })
  }, [])

  return { premiumFeatures, arePremiumFeaturesLoaded, setPremiumFeatures }
}

export default usePremiumFeatures
